// ACTIVATE ZAEHLER ERHOEHUNG IN SELECTION OF TRACKS - ZEILE 276 - 279

//NEU ÜBER DEVICES Get a User's Available Devices

// https://developer.spotify.com/documentation/web-api/reference/#endpoint-get-information-about-the-users-current-playback

import React, { useState } from 'react';
import './SongBoxCountDown.css';
import { useStateValue } from "../../StateProvider";


import { firestore, arrayUnion, increment } from '../../firebase';

//LÄNGE BIS RATING MÖGLICH, evtl. monetization : nach 2 minuten gratis, nach 40 seks kostet
// const timeUntilRating=37;





                  

function SongBoxCountDown({trackid, trackname, songfromuser, emailreceiverrating, songnameemailreceiver}) {

    const [{ countUserRatings, dbUserRatings, dbTrackSelection, userDarfRaten, songsListenedTo, songsRated, songToPlay, subscriptionConfig, userEmail, firebaseUid}, dispatch] = useStateValue();
    
    
    // const [counter, setCounter] = React.useState(timeUntilRating);
    // const [counteruntensong, setCounterTwo] = React.useState(timeUntilRating);
  
  

    //NUR BEIM LADEN resp ändern der variabel!!



//INITIAL VALUE COUNTDOWN ZEIGEN
const [ratingDone, setRatingDone] = useState(
  //inital value
    0


); //hook example
//INITIAL VALUE PLAY BLOCKER AUFHEBEN
const [playBlockerAufgehoben, setplayBlockerAufgehoben] = useState(
  //inital value
    0

); //hook example


const [gesetztesRating, setGesetztesRating] = useState(
  //inital value
    0

); //hook example









//RATING IN FORM ERMITTELN START
function onChangeValue(e) {
   // alert(e.target.value);
//transoform to number  10 braucht es immer
   const ratingscoreasnumber = parseInt(e.target.value, 10)



   //make track unqiue

  const trackunique = Date.now()

                        const songRatingsRef = firestore.collection(dbUserRatings);


                                  //FIREBASE ANONYM LOGIN START

       
                                                  //MUSS UPDATE WERDEN
                        songRatingsRef.doc(songfromuser+"-"+trackid).update({
                          
                          
                          ratingdates: arrayUnion(trackunique),

                          tracknames: arrayUnion(trackunique+"-*_1&7&1&"+trackname),
                         
                          //text: formValue,
                 
                          // createdAts: firebase.firestore.FieldValue.arrayUnion(firebase.firestore.FieldValue.serverTimestamp()),
                          // uid,
                         // trackid: trackid, //wird so genannt in songbox übergabe
                        //  fromspotifyuser: user.id,
                       
                  ratingscores: arrayUnion(trackunique+"-*_1&7&1&"+ratingscoreasnumber)
                       
                        // albumid: track.albumid
                          // artist: track.artist,
                          // name: track.name
                        
                         
              
                          });






      
      
    
                      //ratings zählen in selectionOfTracks

                  const incrementValue = increment(1);


                                                                                                        //NICHT AKTIVER USER, SONDERN USER DER UPGELOADED HAT!!
                  const countRatingsDocId = trackid+"|Firebase-User-Id:"+songfromuser;
                  console.log('countRatings update - docId:', countRatingsDocId, 'collection:', dbTrackSelection, 'firebaseUid:', firebaseUid);
                  const chainCounterRef = firestore.collection(dbTrackSelection).doc(countRatingsDocId);



                  chainCounterRef.update({
                    countRatings: incrementValue,

                    fromspotuserArr: arrayUnion(firebaseUid)


                  }).then(() => {
                    console.log('countRatings successfully incremented for:', countRatingsDocId);
                  }).catch((error) => {
                    console.error('ERROR incrementing countRatings for:', countRatingsDocId, error);
                  });


       //DB ADD MAIL START

      //Firebase Mail extension https://www.youtube.com/watch?v=1nsnNLLnlrg

      // Check user's email preference before sending
      const checkAndSendEmail = async () => {
        try {
          // Check if user wants to receive rating emails
          const prefDoc = await firestore.collection('userEmailPreferences').doc(emailreceiverrating).get();

          const receiveRatingEmails = prefDoc.exists ? prefDoc.data()?.receiveRatingEmails : undefined;
          const sendEmail = !prefDoc.exists || receiveRatingEmails !== false; // Default to true

          if (sendEmail) {
            // User wants to receive emails, so send the notification
            const mailToSend = firestore.collection("mail");

            mailToSend.add({
              to: emailreceiverrating,
              bcc: "catchyrecords@gmail.com",
              message: {
                subject: 'Songcarousel.com: '+songnameemailreceiver+' just received a new rating!',
                html: 'Hi Songcarousel.com User!<br/><br/> Your added song '+songnameemailreceiver+' just received a new rating on <a href="https://www.songcarousel.com/">Songcarousel.com</a>. Log-in at <a href="https://www.songcarousel.com/">Songcarousel.com</a> in order to see your rating.<br/><br/>Cheers<br/>Songcarousel.com<br/><br/><br/><br/><br/>If you want to unsubscribe from these mails visit <a href="https://catchyrecords.com/unsubscribe/">Unsubscribe</a>.',
                text: 'Hi Songcarousel.com User Your added song '+songnameemailreceiver+' just received a new rating on Songcarousel.com. Log-in at Songcarousel.com in order to see your rating. Cheers Songcarousel.com. If you want to unsubscribe from these mails visit https://catchyrecords.com/unsubscribe/' //Falls html nicht geht
              }
            });
          }
        } catch (error) {
          console.error('Error checking email preference:', error);
          // On error, default to sending the email
          const mailToSend = firestore.collection("mail");
          mailToSend.add({
            to: emailreceiverrating,
            bcc: "catchyrecords@gmail.com",
            message: {
              subject: 'Songcarousel.com: '+songnameemailreceiver+' just received a new rating!',
              html: 'Hi Songcarousel.com User!<br/><br/> Your added song '+songnameemailreceiver+' just received a new rating on <a href="https://www.songcarousel.com/">Songcarousel.com</a>. Log-in at <a href="https://www.songcarousel.com/">Songcarousel.com</a> in order to see your rating.<br/><br/>Cheers<br/>Songcarousel.com<br/><br/><br/><br/><br/>If you want to unsubscribe from these mails visit <a href="https://catchyrecords.com/unsubscribe/">Unsubscribe</a>.',
              text: 'Hi Songcarousel.com User Your added song '+songnameemailreceiver+' just received a new rating on Songcarousel.com. Log-in at Songcarousel.com in order to see your rating. Cheers Songcarousel.com. If you want to unsubscribe from these mails visit https://catchyrecords.com/unsubscribe/' //Falls html nicht geht
            }
          });
          console.log(`[FALLBACK] Email sent on error to ${emailreceiverrating}`);
        }
      };

      checkAndSendEmail();

//DB ADD MAIL END


    dispatch({
      type: "SET_COUNTUSERRATINGS",
     countUserRatings: countUserRatings+1,
    });


    const ratingDate = Date.now();
    const ratingDateToString = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(ratingDate);




    // TO DO RATINGS STAT - START
    const dbAllRatings = firestore.collection("allRatings");
    dbAllRatings.doc("allRatingsDoc").update({



                                                       // date,             song,         rating,                  von UserEmail
allinfo: arrayUnion(ratingDateToString+"|"+trackname+"| Rating:"+ratingscoreasnumber+"| Rating von:"+userEmail)




});

        // TO DO RATINGS STAT - ENDE




setRatingDone(1);
  





        
        

         
   


        setGesetztesRating(ratingscoreasnumber);

        // Mark this song as rated in global state
        dispatch({
          type: "SET_SONGRATED",
          songId: trackid,
          rating: ratingscoreasnumber,
        });

        // Clear currently playing song from localStorage since it's been rated
        try {
          const currentlyPlayingSong = localStorage.getItem('currentlyPlayingSong');
          if (currentlyPlayingSong) {
            const parsedSong = JSON.parse(currentlyPlayingSong);
            if (parsedSong.trackid === trackid) {
              localStorage.removeItem('currentlyPlayingSong');
              console.log("🗑️ Cleared currently playing song from localStorage:", trackid);
            }
          }
        } catch (e) {
          console.error("Failed to clear currently playing song from localStorage:", e);
        }


}; //RATING ON CLICK END





if (playBlockerAufgehoben!==1 && ratingDone===1 ) {
dispatch({
  type: "SET_PLAYBLOCKER",
  playBlocker: 0,

});



    dispatch({
      type: "SET_SHOWINITIALIZEPLAYERBUTTON",
      showInitializePlayerButton: 1,
    });


    dispatch({
      type: "SET_USERDARFRATEN",
      userDarfRaten: 0,
    });


setplayBlockerAufgehoben(1);






};//playblocker aufheben ende COUNTER 0 ENDE










    return (
      <div>
       {/* Handle currently playing song separately */}
       {(ratingDone!==1) && !songsRated[trackid] && songToPlay === trackid && (userDarfRaten!==1) && !songsListenedTo[trackid]?
        (
            <div style={{fontSize: '12px', lineHeight: '1.3', padding: '2px 0'}}>
              <p style={{margin: '1px 0'}}>Rating will be possible after</p>
              <p style={{margin: '1px 0'}}>you listened at least {subscriptionConfig?.listeningTimeRequired || 55} seconds</p>
              <p style={{margin: '1px 0'}}>in Spotify Player above</p>
            </div>
          ) : (<div>&nbsp;</div>)}

       {/* Handle other songs during playback */}
       {(ratingDone!==1) && !songsRated[trackid] && songToPlay !== trackid && (userDarfRaten!==1) && !songsListenedTo[trackid]?
        (
            <div style={{fontSize: '12px', lineHeight: '1.3', padding: '2px 0'}}>
              <p style={{margin: '1px 0'}}>wait until current song is played and rated.</p>
            </div>
          ) : (<div>&nbsp;</div>)}





        {/* IF IN RETURN : RATINGBOX ZEIGEN BEI 0*/}
        {(ratingDone!==1) && !songsRated[trackid] && ((userDarfRaten===1) || songsListenedTo[trackid])?
        (//RATING CONDITION START
            <div className="ratingBox" onChange={onChangeValue}>
                <div className="ratingTitle">PLEASE RATE:</div>
                <label className="ratingOption">
                    <input type="radio" value="4" name="userrating" className="rgRating"/>
                    <span>🔥 Added to my playlist!</span>
                </label>
                <label className="ratingOption">
                    <input type="radio" value="3" name="userrating" className="rgRating"/>
                    <span>🎉 Great Song</span>
                </label>
                <label className="ratingOption">
                    <input type="radio" value="2" name="userrating" className="rgRating"/>
                    <span>🟢 Mediocore</span>
                </label>
                <label className="ratingOption">
                    <input type="radio" value="1" name="userrating" className="rgRating"/>
                    <span>😉 Not for me</span>
                </label>
            </div>




        //RATING CONDITION END
        ) : (
       <p></p> //<p></p>  muss bleiben!!
      )}
{(ratingDone===1) || songsRated[trackid]?
(<div className="songIsRatedBox"><p>Song successfully rated </p>
<p>with:&nbsp;
  {(gesetztesRating===1 || songsRated[trackid]===1)? ("😉 Not for me"):("")}
  {(gesetztesRating===2 || songsRated[trackid]===2)? ("🟢 Mediocore"):("")}
  {(gesetztesRating===3 || songsRated[trackid]===3)? ("🎉 Great Song"):("")}
  {(gesetztesRating===4 || songsRated[trackid]===4)? ("🔥 Added to my playlist!"):("")}
</p>
</div>


  ) : (
    <p></p>  //<p></p>  muss bleiben!!
  )}


        </div>
    )
}

export default SongBoxCountDown
